import styled from 'styled-components';

import Placeholder from '@assets/images/promotions/ticket_placeholder.webp';

export const Wrapper = styled.div<{ $bg: string | null }>`
	padding: 21px 16px;
	height: 132px;
	border-radius: 12px;

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	background-image: url('${({ $bg }) => ($bg ? $bg : Placeholder)}');
	background-repeat: no-repeat;
	background-position: center right;
	background-size: cover;
`;

export const PrizeName = styled.div`
	font-size: 18px;
	line-height: 25px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	display: flex;
	gap: 5px;
	align-items: center;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};
	}
`;

export const ButtonWrapper = styled.div``;
